import { baseApi } from 'api'
import { filterEmpty } from 'helpers/object'
import { ApiResponse } from 'helpers/types'
import {
  DeliveryDateResponse,
  DeliveryTypeResponse,
  DepartureCourierScheduleResponse,
  OrderCalculatorItemResponse
} from 'schema'

import {
  DeliveryCostRequest,
  DeliveryCostResponse,
  TDeliveryDestinationTypeRequestData,
  TDeliveryInfoDateRequest,
  TDeliveryInfoDateResponse,
  TDeliveryTypeRequestData,
  TDeliveryTypeResponseData
} from '../types'

export const deliveryInfoApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    findDepartureDeliveryType: build.mutation<TDeliveryTypeResponseData, TDeliveryTypeRequestData>({
      query: ({ latitude, longitude, address, customerId }) => ({
        url: 'delivery-info/departure-type',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined
        }
      }),
      transformResponse: (response: ApiResponse<DeliveryTypeResponse>) => response.data.deliveryType
    }),
    findDestinationDeliveryType: build.mutation<TDeliveryTypeResponseData, TDeliveryDestinationTypeRequestData>({
      query: ({ latitude, longitude, address, customerId, departureTerminalId }) => ({
        url: 'delivery-info/destination-type',
        method: 'GET',
        params: {
          latitude,
          longitude,
          address,
          customerId: customerId || undefined,
          departureTerminalId: departureTerminalId || undefined
        }
      }),
      transformResponse: (response: ApiResponse<DeliveryTypeResponse>) => response.data.deliveryType
    }),
    getDeliveryCost: build.mutation<DeliveryCostResponse['deliveryInfo'], DeliveryCostRequest>({
      query: (data) => ({
        url: 'order-delivery-info',
        method: 'POST',
        body: filterEmpty(data)
      }),
      transformResponse: (response: ApiResponse<OrderCalculatorItemResponse>) => response.data.deliveryInfo
    }),
    findDeliveryInfoDate: build.mutation<TDeliveryInfoDateResponse, TDeliveryInfoDateRequest>({
      query: ({
        departureDate,
        departureTerminalId,
        destinationTerminalId,
        type,
        destinationLatitude,
        destinationLongitude,
        destinationType
      }) => ({
        url: 'delivery-info/date',
        method: 'GET',
        params: {
          departureDate,
          departureTerminalId,
          destinationTerminalId,
          type,
          destinationLatitude,
          destinationLongitude,
          destinationType
        }
      }),
      transformResponse: (response: ApiResponse<DeliveryDateResponse>) => response.data
    }),
    getDeliveryInfoDepartureCourierSchedule: build.query<
      string[],
      {
        latitude: string
        longitude: string
      }
    >({
      query: ({ latitude, longitude }) => ({
        url: 'delivery-info/departure-courier-schedule',
        method: 'GET',
        params: {
          latitude,
          longitude
        }
      }),
      transformResponse: (response: ApiResponse<DepartureCourierScheduleResponse>) => response.data.schedule
    })
  }),
  overrideExisting: false
})

export const {
  useFindDepartureDeliveryTypeMutation,
  useFindDestinationDeliveryTypeMutation,
  useFindDeliveryInfoDateMutation,
  useGetDeliveryCostMutation,
  useGetDeliveryInfoDepartureCourierScheduleQuery,
  useLazyGetDeliveryInfoDepartureCourierScheduleQuery
} = deliveryInfoApi
